export const matchAcronyms: string[] = ['1.MD', 'WD', '2.MD', '1.MS', 'WS', 'XD', '2.MS', '3.MS'];
